// extracted by mini-css-extract-plugin
export default {"faqBlock":"views-ContentPage-components-themes-BGH-faqContainer__faqBlock--A6E6x"};